import { render, staticRenderFns } from "./setForm.vue?vue&type=template&id=53715204&scoped=true&"
import script from "./setForm.vue?vue&type=script&lang=js&"
export * from "./setForm.vue?vue&type=script&lang=js&"
import style0 from "./setForm.vue?vue&type=style&index=0&id=53715204&prod&lang=less&scoped=true&"
import style1 from "./setForm.vue?vue&type=style&index=1&id=53715204&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53715204",
  null
  
)

export default component.exports